import React from "react";
import ReactDOM from "react-dom/client";
import "../src/styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import axios from "axios";
import $ from "jquery";
import AppConstant from "./assets/js/AppConstant";
import AppUtility from "./assets/js/AppUtility";
import dayjs from "dayjs";
import "dayjs/locale/th";

dayjs.locale("th");
// dayjs.extend(buddhistEra)
axios.defaults.baseURL = AppConstant?.MAIN_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.common["X-Api-Key"] = AppConstant.X_API_KEY;

axios.interceptors.request.use(
  (config) => {
    const currentToken = localStorage.getItem("access_token");
    if (currentToken) {
      config.headers.Authorization = `Bearer ${currentToken}`;
    } else {
      delete config.headers.Authorization;
    }
    // if(!config.close_loading){
    let _t = Date.now();
    $("#root").prepend(
      '<div class="spinner_area" data-id="' +
        _t +
        '"><div class="cover-spinner"></div></div>'
    );
    $(".spinner_area[data-id=" + _t + "]").fadeIn(100);
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    $(".spinner_area:first").fadeOut(100).remove();
    return response;
  },
  (error) => {
    $(".spinner_area:first").fadeOut(100).remove();

    AppUtility.AxiosResponseError(error);
    // setTimeout(function(){
    //  $(".spinner_area:first").fadeOut(100).remove();
    // }, 300);
    // return Promise.reject(error);
    throw error;
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
